__turbopack_context__.v({
  "mobileOnly": "YYQLsq_mobileOnly",
});
